var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.files, function(file) {
        return _c("div", { key: file.id, staticClass: "col-12 mb-2" }, [
          _c(
            "div",
            { staticClass: "row align-items-center border-primary rounded-lg" },
            [
              _c("vs-icon", {
                staticClass: "col-1",
                attrs: { icon: "description", size: "25px", color: "primary" }
              }),
              _c("b", { staticClass: "w-100 text-center col-10" }, [
                _vm._v(" " + _vm._s(file.name) + " ")
              ]),
              _c("vs-button", {
                staticClass: "col-1",
                attrs: { color: "danger", type: "flat", icon: "clear" },
                on: {
                  click: function($event) {
                    return _vm.removeFile(file.id)
                  }
                }
              })
            ],
            1
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }